/* eslint-disable @typescript-eslint/no-explicit-any */
export class Deferred<T> {
    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            this.resolve = <any>resolve;
            this.reject = reject;
        });
    }

    promise: Promise<T>;
    resolve!: (value?: T | PromiseLike<T>) => void;
    reject!: (reason?: any) => void;
}
